/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateJobExecutionTypeQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("TemplateJobExecutionTypeQueryOperator");
    }

    getFixupPrototypeFunction() { return TemplateJobExecutionTypeQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<TemplateJobExecutionTypeQueryOperator>): TemplateJobExecutionTypeQueryOperator {
        let obj = Object.assign(new TemplateJobExecutionTypeQueryOperator(), model);
        TemplateJobExecutionTypeQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateJobExecutionTypeQueryOperator>): TemplateJobExecutionTypeQueryOperator {
        if (!model) return null;
        return TemplateJobExecutionTypeQueryOperator.newInstance(<TemplateJobExecutionTypeQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateJobExecutionTypeQueryOperator) {
        if (!obj) return;

        models.TemplateJobExecutionTypeQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateJobExecutionTypeQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TemplateJobExecutionTypeQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Template job execution types to include
     */
    execution_types: Array<models.TemplateExecutionType>;

}
